import React from "react";
import { useButtonsActions } from "../../hooks/useButtonsActions";
import ChatIcon from "../../images/attendance.svg";
import Browser from "../../images/browser.svg";
import Email from "../../images/email.svg";
import { Button } from "../Button";
import { Subtitle } from "../Subtitle";
import "./styles.scss";


interface DuvidasProps {}

function Duvidas({}: DuvidasProps) {
  const { sendMail, openSite, handleAttendance } = useButtonsActions();

  return (
    <section id="duvidas">
      <div>
        <Subtitle text="Ficou alguma dúvida?" />
        <p>
          Converse com a gente. A nossa equipe de atendimento está disponível de
          Segunda a Sexta de 09:00 a 18:00
        </p>

        <div className="containerButtons">
          <Button
            text="Atendimento"
            onClick={handleAttendance}
            title="Atendimento"
            id="callDuvidas"
          >
            <img src={ChatIcon} alt="Chat Icon" />
          </Button>
          <Button
            text="E-mail"
            onClick={sendMail}
            title="boletoparcelado@koin.com.br"
            id="emailDuvidas"
          >
            <img src={Email} alt="Email Icon" />
          </Button>
          <Button
            text="Visite nosso site"
            onClick={openSite}
            title="koin.com.br"
            id="siteDuvidas"
          >
            <img src={Browser} alt="Browser Icon" />
          </Button>
        </div>
      </div>
    </section>
  );
}

export { Duvidas };

